export default "__VITE_ASSET__CFndNh75__"